import styled from 'styled-components'
import { colors } from '../../../constants'

interface InputProps {
    borderColor?: string | boolean
    error?: string | boolean
}

const Input = styled.div<InputProps>`
    background: ${colors.greylightest};
    ${({ borderColor }) => (borderColor ? `border: 1px solid ${borderColor};` : `border: 1px solid ${colors.greylight};`)}
    border-radius: 3px;
    outline: none;
    width: 20px;
    height: 20px;
    text-align: center;
    cursor: pointer;
    &:active,
    &:focus,
    &:hover {
        border: 1px solid ${colors.grey};
    }
    color: ${colors.bluedarkest};

    ${({ error }) =>
        error &&
        `
    border: 1px solid ${colors.red};
  `}
`

export { Input }
